import React, { useState } from "react";

import { Modal, ModalHeader, ModalBody } from "reactstrap";

const SetCategoryFieldModal = ({
  isOpen = false,
  toggle,
  nextToggle,
  subCategoryField,
}) => {
  console.log("Sub category : ", subCategoryField);
  const [initialValues] = useState({
    title:
      subCategoryField && subCategoryField.title ? subCategoryField.title : "",
    fieldType:
      subCategoryField && subCategoryField.fieldType
        ? subCategoryField.fieldType
        : "",
    isRequiredField:
      subCategoryField && subCategoryField.isRequiredField
        ? subCategoryField.isRequiredField
        : false,
    isUniqueField:
      subCategoryField && subCategoryField.isUniqueField
        ? subCategoryField.isUniqueField
        : false,
    defaultValue:
      subCategoryField && subCategoryField.defaultValue
        ? subCategoryField.defaultValue
        : "",
  });

  const handleChange = (e) => {
    toggle();
    nextToggle({
      ...initialValues,
      fieldType: e.target.value,
    });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader className="modal-header px-4" toggle={toggle}>
        <div className="modal-header px-4">
          <div className="modal-title" id="#addCategorylabel">
            {subCategoryField
              ? subCategoryField.subCategory
              : "subCategoryField Name"}
          </div>
          {/* <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={toggle}
          >
            <span aria-hidden="true">&times;</span>
          </button> */}
        </div>
      </ModalHeader>

      <ModalBody className="modal-body px-4 py-5">
        <div>
          <h6 className="modalBodyHeading">
            Select a field for your content type
          </h6>
          <div className="row radioContentCategory">
            <div className="col-md-6">
              <div className="radiobtn">
                <input
                  type="radio"
                  id="string"
                  name="fieldType"
                  value="string"
                  onChange={(e) => {
                    if (initialValues.fieldType === "string")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "string"}
                  onClick={handleChange}
                />
                <label htmlFor="string">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#FEAB04" />
                    <path
                      d="M10.934 5.976H12.754L16.52 16H14.77L13.86 13.424H9.828L8.918 16H7.168L10.934 5.976ZM13.328 11.982L12.278 9.028L11.886 7.852H11.802L11.41 9.028L10.36 11.982H13.328ZM17.4774 5.976H19.0314V9.07L18.9474 10.022H19.0314C19.218 9.72333 19.5027 9.46667 19.8854 9.252C20.268 9.028 20.7254 8.916 21.2574 8.916C21.696 8.916 22.1114 9.00933 22.5034 9.196C22.9047 9.37333 23.2547 9.62533 23.5534 9.952C23.852 10.2787 24.09 10.666 24.2674 11.114C24.4447 11.5527 24.5334 12.038 24.5334 12.57C24.5334 13.102 24.4447 13.592 24.2674 14.04C24.09 14.4787 23.852 14.8613 23.5534 15.188C23.2547 15.5147 22.9047 15.7713 22.5034 15.958C22.1114 16.1353 21.696 16.224 21.2574 16.224C20.7254 16.224 20.268 16.1167 19.8854 15.902C19.5027 15.678 19.218 15.4167 19.0314 15.118H18.9474V16H17.4774V5.976ZM20.9634 14.782C21.2247 14.782 21.4767 14.7307 21.7194 14.628C21.9714 14.5253 22.186 14.3807 22.3634 14.194C22.55 13.998 22.6994 13.7647 22.8114 13.494C22.9234 13.2233 22.9794 12.9153 22.9794 12.57C22.9794 12.2247 22.9234 11.9167 22.8114 11.646C22.6994 11.3753 22.55 11.1467 22.3634 10.96C22.186 10.764 21.9714 10.6147 21.7194 10.512C21.4767 10.4093 21.2247 10.358 20.9634 10.358C20.6927 10.358 20.436 10.4093 20.1934 10.512C19.9507 10.6147 19.736 10.7593 19.5494 10.946C19.372 11.1327 19.2274 11.366 19.1154 11.646C19.0034 11.9167 18.9474 12.2247 18.9474 12.57C18.9474 12.9153 19.0034 13.228 19.1154 13.508C19.2274 13.7787 19.372 14.0073 19.5494 14.194C19.736 14.3807 19.9507 14.5253 20.1934 14.628C20.436 14.7307 20.6927 14.782 20.9634 14.782Z"
                      fill="white"
                    />
                  </svg>

                  <span className="ml-4">Titles,</span>
                  <span>names,</span>
                  <span>listof names</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="number"
                  name="fieldType"
                  value="number"
                  onChange={(e) => {
                    if (initialValues.fieldType === "number")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "number"}
                  onClick={handleChange}
                />
                <label htmlFor="number">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#DB412D" />
                    <path
                      d="M7.926 16V8.3L6.148 9.07L5.56 7.74L8.374 6.424H9.48V16H7.926ZM11.3989 16V14.53C11.9402 13.998 12.4395 13.4987 12.8969 13.032C13.0929 12.836 13.2889 12.6353 13.4849 12.43C13.6902 12.2247 13.8815 12.0333 14.0589 11.856C14.2362 11.6693 14.3995 11.5013 14.5489 11.352C14.6982 11.1933 14.8149 11.0673 14.8989 10.974C15.0762 10.7687 15.2302 10.5867 15.3609 10.428C15.4915 10.2693 15.5989 10.1153 15.6829 9.966C15.7669 9.81667 15.8275 9.66733 15.8649 9.518C15.9115 9.36867 15.9349 9.20067 15.9349 9.014C15.9349 8.846 15.8975 8.68267 15.8229 8.524C15.7575 8.36533 15.6595 8.22533 15.5289 8.104C15.3982 7.97333 15.2349 7.87067 15.0389 7.796C14.8522 7.712 14.6329 7.67 14.3809 7.67C14.1382 7.67 13.9235 7.712 13.7369 7.796C13.5595 7.87067 13.4055 7.97333 13.2749 8.104C13.1442 8.22533 13.0369 8.36067 12.9529 8.51C12.8689 8.65 12.8082 8.79 12.7709 8.93L11.3569 8.356C11.4222 8.132 11.5342 7.894 11.6929 7.642C11.8515 7.39 12.0569 7.15667 12.3089 6.942C12.5609 6.72733 12.8595 6.55 13.2049 6.41C13.5595 6.27 13.9609 6.2 14.4089 6.2C14.8849 6.2 15.3142 6.27467 15.6969 6.424C16.0795 6.57333 16.4062 6.774 16.6769 7.026C16.9475 7.278 17.1529 7.572 17.2929 7.908C17.4422 8.244 17.5169 8.60333 17.5169 8.986C17.5169 9.28467 17.4702 9.574 17.3769 9.854C17.2929 10.134 17.1762 10.4047 17.0269 10.666C16.8869 10.918 16.7235 11.156 16.5369 11.38C16.3595 11.604 16.1775 11.8093 15.9909 11.996C15.9442 12.0427 15.8742 12.1127 15.7809 12.206C15.6875 12.2993 15.5755 12.4113 15.4449 12.542C15.3235 12.6633 15.1882 12.794 15.0389 12.934C14.8895 13.0833 14.7402 13.2327 14.5909 13.382L13.4569 14.516L13.4709 14.572H17.6289V16H11.3989ZM22.028 16.224C21.692 16.224 21.356 16.1773 21.02 16.084C20.684 15.9907 20.3667 15.846 20.068 15.65C19.7787 15.4447 19.5174 15.188 19.284 14.88C19.0507 14.572 18.8734 14.2033 18.752 13.774L20.208 13.172C20.3387 13.676 20.5627 14.0633 20.88 14.334C21.1974 14.6047 21.58 14.74 22.028 14.74C22.252 14.74 22.4667 14.7027 22.672 14.628C22.8867 14.5533 23.0734 14.4507 23.232 14.32C23.3907 14.18 23.5167 14.0213 23.61 13.844C23.7034 13.6573 23.75 13.452 23.75 13.228C23.75 13.004 23.6987 12.7987 23.596 12.612C23.5027 12.4253 23.372 12.2667 23.204 12.136C23.036 12.0053 22.8354 11.9027 22.602 11.828C22.378 11.7533 22.1354 11.716 21.874 11.716H21.048V10.274H21.79C22.014 10.274 22.2194 10.246 22.406 10.19C22.602 10.1247 22.7747 10.036 22.924 9.924C23.0734 9.812 23.19 9.672 23.274 9.504C23.358 9.32667 23.4 9.126 23.4 8.902C23.4 8.51933 23.26 8.22067 22.98 8.006C22.7094 7.782 22.364 7.67 21.944 7.67C21.7107 7.67 21.5054 7.70267 21.328 7.768C21.16 7.83333 21.0154 7.922 20.894 8.034C20.7727 8.146 20.67 8.272 20.586 8.412C20.5114 8.54267 20.4507 8.678 20.404 8.818L18.976 8.216C19.0507 7.992 19.1674 7.76333 19.326 7.53C19.4847 7.28733 19.6854 7.068 19.928 6.872C20.1707 6.676 20.4554 6.51733 20.782 6.396C21.118 6.26533 21.5054 6.2 21.944 6.2C22.392 6.2 22.8027 6.26533 23.176 6.396C23.5494 6.52667 23.8714 6.70867 24.142 6.942C24.4127 7.17533 24.6227 7.45067 24.772 7.768C24.9214 8.08533 24.996 8.43067 24.996 8.804C24.996 9.07467 24.9587 9.322 24.884 9.546C24.8187 9.77 24.7254 9.97067 24.604 10.148C24.4827 10.316 24.3474 10.4607 24.198 10.582C24.0487 10.7033 23.8947 10.806 23.736 10.89V10.974C23.9507 11.0673 24.156 11.1887 24.352 11.338C24.548 11.478 24.716 11.646 24.856 11.842C25.0054 12.038 25.122 12.262 25.206 12.514C25.29 12.7567 25.332 13.0227 25.332 13.312C25.332 13.732 25.248 14.124 25.08 14.488C24.912 14.8427 24.6787 15.1507 24.38 15.412C24.0907 15.664 23.7454 15.86 23.344 16C22.9427 16.1493 22.504 16.224 22.028 16.224Z"
                      fill="white"
                    />
                  </svg>
                  Number
                  <span className="ml-4">Every that is number</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="date"
                  name="fieldType"
                  value="date"
                  onChange={(e) => {
                    if (initialValues.fieldType === "date")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "date"}
                  onClick={handleChange}
                />
                <label htmlFor="date">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#AB74C9" />
                    <path
                      d="M20.0833 5.75H11.9167C11.2723 5.75 10.75 6.27233 10.75 6.91667V15.0833C10.75 15.7277 11.2723 16.25 11.9167 16.25H20.0833C20.7277 16.25 21.25 15.7277 21.25 15.0833V6.91667C21.25 6.27233 20.7277 5.75 20.0833 5.75Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.958 9.83203C14.4413 9.83203 14.833 9.44028 14.833 8.95703C14.833 8.47378 14.4413 8.08203 13.958 8.08203C13.4748 8.08203 13.083 8.47378 13.083 8.95703C13.083 9.44028 13.4748 9.83203 13.958 9.83203Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.2503 12.7487L18.3337 9.83203L11.917 16.2487"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Date
                  <span className="ml-4">Event date</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="media"
                  name="fieldType"
                  value="media"
                  onChange={(e) => {
                    if (initialValues.fieldType === "media")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "media"}
                  onClick={handleChange}
                />
                <label htmlFor="media">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#AB74C9" />
                    <path
                      d="M20.0833 5.75H11.9167C11.2723 5.75 10.75 6.27233 10.75 6.91667V15.0833C10.75 15.7277 11.2723 16.25 11.9167 16.25H20.0833C20.7277 16.25 21.25 15.7277 21.25 15.0833V6.91667C21.25 6.27233 20.7277 5.75 20.0833 5.75Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M13.958 9.83203C14.4413 9.83203 14.833 9.44028 14.833 8.95703C14.833 8.47378 14.4413 8.08203 13.958 8.08203C13.4748 8.08203 13.083 8.47378 13.083 8.95703C13.083 9.44028 13.4748 9.83203 13.958 9.83203Z"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M21.2503 12.7487L18.3337 9.83203L11.917 16.2487"
                      stroke="white"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Media
                  <span className="ml-4">Every that is number</span>
                </label>
              </div>
            </div>
            <div className="col-md-6">
              <div className="radiobtn">
                <input
                  type="radio"
                  id="description"
                  name="fieldType"
                  value="description"
                  onChange={(e) => {
                    if (initialValues.fieldType === "description")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "description"}
                  onClick={handleChange}
                />
                <label htmlFor="description">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#D58E00" />
                    <path
                      d="M8 7H24"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M8.5 11H19.5"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                    <path
                      d="M8.5 15H16.5"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                  Text
                  <span className="ml-4">Descriptions</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="boolean"
                  name="fieldType"
                  value="boolean"
                  onChange={(e) => {
                    if (initialValues.fieldType === "boolean")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "boolean"}
                  onClick={handleChange}
                />
                <label htmlFor="boolean">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#FEAB04" />
                    <path
                      d="M10.934 5.976H12.754L16.52 16H14.77L13.86 13.424H9.828L8.918 16H7.168L10.934 5.976ZM13.328 11.982L12.278 9.028L11.886 7.852H11.802L11.41 9.028L10.36 11.982H13.328ZM17.4774 5.976H19.0314V9.07L18.9474 10.022H19.0314C19.218 9.72333 19.5027 9.46667 19.8854 9.252C20.268 9.028 20.7254 8.916 21.2574 8.916C21.696 8.916 22.1114 9.00933 22.5034 9.196C22.9047 9.37333 23.2547 9.62533 23.5534 9.952C23.852 10.2787 24.09 10.666 24.2674 11.114C24.4447 11.5527 24.5334 12.038 24.5334 12.57C24.5334 13.102 24.4447 13.592 24.2674 14.04C24.09 14.4787 23.852 14.8613 23.5534 15.188C23.2547 15.5147 22.9047 15.7713 22.5034 15.958C22.1114 16.1353 21.696 16.224 21.2574 16.224C20.7254 16.224 20.268 16.1167 19.8854 15.902C19.5027 15.678 19.218 15.4167 19.0314 15.118H18.9474V16H17.4774V5.976ZM20.9634 14.782C21.2247 14.782 21.4767 14.7307 21.7194 14.628C21.9714 14.5253 22.186 14.3807 22.3634 14.194C22.55 13.998 22.6994 13.7647 22.8114 13.494C22.9234 13.2233 22.9794 12.9153 22.9794 12.57C22.9794 12.2247 22.9234 11.9167 22.8114 11.646C22.6994 11.3753 22.55 11.1467 22.3634 10.96C22.186 10.764 21.9714 10.6147 21.7194 10.512C21.4767 10.4093 21.2247 10.358 20.9634 10.358C20.6927 10.358 20.436 10.4093 20.1934 10.512C19.9507 10.6147 19.736 10.7593 19.5494 10.946C19.372 11.1327 19.2274 11.366 19.1154 11.646C19.0034 11.9167 18.9474 12.2247 18.9474 12.57C18.9474 12.9153 19.0034 13.228 19.1154 13.508C19.2274 13.7787 19.372 14.0073 19.5494 14.194C19.736 14.3807 19.9507 14.5253 20.1934 14.628C20.436 14.7307 20.6927 14.782 20.9634 14.782Z"
                      fill="white"
                    />
                  </svg>
                  Boolean
                  <span className="ml-4">Yes or no</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="relation"
                  name="fieldType"
                  value="relation"
                  onChange={(e) => {
                    if (initialValues.fieldType === "relation")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "relation"}
                  onClick={handleChange}
                />
                <label htmlFor="relation">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#66B311" />
                    <path
                      d="M10.934 5.976H12.754L16.52 16H14.77L13.86 13.424H9.828L8.918 16H7.168L10.934 5.976ZM13.328 11.982L12.278 9.028L11.886 7.852H11.802L11.41 9.028L10.36 11.982H13.328ZM17.4774 5.976H19.0314V9.07L18.9474 10.022H19.0314C19.218 9.72333 19.5027 9.46667 19.8854 9.252C20.268 9.028 20.7254 8.916 21.2574 8.916C21.696 8.916 22.1114 9.00933 22.5034 9.196C22.9047 9.37333 23.2547 9.62533 23.5534 9.952C23.852 10.2787 24.09 10.666 24.2674 11.114C24.4447 11.5527 24.5334 12.038 24.5334 12.57C24.5334 13.102 24.4447 13.592 24.2674 14.04C24.09 14.4787 23.852 14.8613 23.5534 15.188C23.2547 15.5147 22.9047 15.7713 22.5034 15.958C22.1114 16.1353 21.696 16.224 21.2574 16.224C20.7254 16.224 20.268 16.1167 19.8854 15.902C19.5027 15.678 19.218 15.4167 19.0314 15.118H18.9474V16H17.4774V5.976ZM20.9634 14.782C21.2247 14.782 21.4767 14.7307 21.7194 14.628C21.9714 14.5253 22.186 14.3807 22.3634 14.194C22.55 13.998 22.6994 13.7647 22.8114 13.494C22.9234 13.2233 22.9794 12.9153 22.9794 12.57C22.9794 12.2247 22.9234 11.9167 22.8114 11.646C22.6994 11.3753 22.55 11.1467 22.3634 10.96C22.186 10.764 21.9714 10.6147 21.7194 10.512C21.4767 10.4093 21.2247 10.358 20.9634 10.358C20.6927 10.358 20.436 10.4093 20.1934 10.512C19.9507 10.6147 19.736 10.7593 19.5494 10.946C19.372 11.1327 19.2274 11.366 19.1154 11.646C19.0034 11.9167 18.9474 12.2247 18.9474 12.57C18.9474 12.9153 19.0034 13.228 19.1154 13.508C19.2274 13.7787 19.372 14.0073 19.5494 14.194C19.736 14.3807 19.9507 14.5253 20.1934 14.628C20.436 14.7307 20.6927 14.782 20.9634 14.782Z"
                      fill="white"
                    />
                  </svg>
                  Relation
                  <span className="ml-4">Refers to a contentt type</span>
                </label>
              </div>
              <div className="radiobtn">
                <input
                  type="radio"
                  id="json"
                  name="fieldType"
                  value="json"
                  onChange={(e) => {
                    if (initialValues.fieldType === "json")
                      return handleChange(e);
                  }}
                  checked={initialValues.fieldType === "json"}
                  onClick={handleChange}
                />
                <label htmlFor="json">
                  <svg
                    width="31"
                    height="21"
                    viewBox="0 0 31 21"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect width="31" height="21" rx="2" fill="#1D4DDE" />
                    <path
                      d="M8.008 4.912H11.172V6.2H9.492V16.448H11.172V17.736H8.008V4.912ZM11.9991 16L16.1571 5.976H17.6551L13.4971 16H11.9991ZM18.4812 17.736V16.448H18.7472C19.0459 16.448 19.3025 16.3407 19.5172 16.126C19.7319 15.9113 19.8392 15.6173 19.8392 15.244V13.032C19.8392 12.556 19.9139 12.1873 20.0632 11.926C20.2125 11.6553 20.4599 11.4687 20.8052 11.366V11.282C20.4599 11.17 20.2125 10.9833 20.0632 10.722C19.9139 10.4513 19.8392 10.0827 19.8392 9.616V7.404C19.8392 7.03067 19.7319 6.73667 19.5172 6.522C19.3025 6.30733 19.0459 6.2 18.7472 6.2H18.4812V4.912H18.8732C19.6385 4.912 20.2359 5.13133 20.6652 5.57C21.1039 6.00867 21.3232 6.60133 21.3232 7.348V9.616C21.3232 9.97067 21.4165 10.2367 21.6032 10.414C21.7992 10.5913 22.0279 10.68 22.2892 10.68V11.968C22.0279 11.968 21.7992 12.0567 21.6032 12.234C21.4165 12.4113 21.3232 12.6773 21.3232 13.032V15.3C21.3232 16.0467 21.1039 16.6393 20.6652 17.078C20.2359 17.5167 19.6385 17.736 18.8732 17.736H18.4812Z"
                      fill="white"
                    />
                  </svg>
                  JSON
                  <span className="ml-4">Data in JSON format</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default SetCategoryFieldModal;
